import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter} from '@angular/core';
import {trigger, style, animate, transition, query, keyframes} from '@angular/animations';
import {CommonService} from "../common.service";
import {ApiService} from "../api.service";

@Component({
  selector: 'app-case-practice-cooperation-begin',
  animations: [
   trigger('taskBookAnimation', [
       transition(':enter', [
         style({opacity: 0}),
         query('#taskWrap', style({opacity: 0, transform: 'scale(0, 0)'})),
         query('#startBtn', style({opacity: 0, transform: 'scale(0, 0)'})),
         animate('200ms ease-in', style({opacity: 1})),
         query('#taskWrap', animate('500ms', keyframes([
           style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
           style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
           style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
           style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
           style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
           style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
           style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
           style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
           style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
           style({transform: 'scale(1, 1)', opacity: 1})
         ]))),
         query('#startBtn', animate('500ms', keyframes([
           style({transform: 'scale(0.1, 0.1)', opacity: 0.1}),
           style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
           style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
           style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
           style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
           style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
           style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
           style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
           style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
           style({transform: 'scale(1, 1)', opacity: 1})
         ]))),
       ]),
       transition('* => void', [
         query('#taskWrap', animate('500ms', keyframes([
           style({transform: 'scale(1, 1)', opacity: 1}),
           style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
           style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
           style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
           style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
           style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
           style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
           style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
           style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
           style({transform: 'scale(0.1, 0.1)', opacity: 0.1})
         ]))),
         query('#startBtn', animate('500ms', keyframes([
           style({transform: 'scale(1, 1)', opacity: 1}),
           style({transform: 'scale(0.9, 0.9)', opacity: 0.9}),
           style({transform: 'scale(0.8, 0.8)', opacity: 0.8}),
           style({transform: 'scale(0.7, 0.7)', opacity: 0.7}),
           style({transform: 'scale(0.6, 0.6)', opacity: 0.6}),
           style({transform: 'scale(0.5, 0.5)', opacity: 0.5}),
           style({transform: 'scale(0.4, 0.4)', opacity: 0.4}),
           style({transform: 'scale(0.3, 0.3)', opacity: 0.3}),
           style({transform: 'scale(0.2, 0.2)', opacity: 0.2}),
           style({transform: 'scale(0.1, 0.1)', opacity: 0.1})
         ]))),
       ])
    ])
  ],
  templateUrl: './case-practice-cooperation-begin.component.html',
  styleUrls: ['./case-practice-cooperation-begin.component.css',]
})
export class CasePracticeCooperationBeginComponent implements OnInit, AfterViewInit  {
    @Input() exerciseId:number;
    @Output() onGoToList = new EventEmitter<any>();
    @Output() onGoToNextStep = new EventEmitter<any>();

    taskBook: any;

  constructor(
      private commonService:CommonService,
      private apiService: ApiService
  ) { }

  ngOnInit() {
      this.apiService.ajax({
          'type':'get',
          'url':'/api/taskBook/'+this.exerciseId
      }).subscribe(result=>{
          this.taskBook = result;
      });
  }

    ngAfterViewInit(){
        this.commonService.initPage({
            'backgroundColor':'white'
        });
    }

    close(){
        this.onGoToList.emit(true);
    }

    goToNextStep(){
        this.onGoToNextStep.emit(3);
        this.apiService.ajax({
            'type':'post',
            'url':'/api/pnoStorePoint/'+this.exerciseId,
            'data':{
                'pno_store_point_id':10
            }
        }).subscribe(result=>{});
    }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation-begin/case-practice-cooperation-begin.component.ts